var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 73,
    viewBox: "0 0 136 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.9008 1.27904C73.7322 0.454992 72.6643 0.223785 72.1696 0.904241L21.406 70.7345C20.8568 71.4899 21.3968 72.5491 22.3311 72.5491L33.5099 72.5491C34.0956 72.5491 34.6458 72.2689 34.9901 71.7953L76.3626 14.8835C76.5223 14.6638 76.5822 14.3872 76.5278 14.1212L73.9008 1.27904Z",
    fill: "url(#paint0_linear_25514_11391)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8141 71.7953C54.4698 72.2689 53.9195 72.5491 53.3339 72.5491H42.1551C41.2207 72.5491 40.6808 71.4899 41.2299 70.7345L87.0117 7.75722C87.4936 7.09438 88.5302 7.29305 88.7326 8.08702L91.8378 20.2714C91.9088 20.5501 91.8521 20.846 91.6829 21.0787L54.8141 71.7953Z",
    fill: "url(#paint1_linear_25514_11391)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4672 71.7953C74.123 72.2689 73.5727 72.5491 72.987 72.5491H61.8082C60.8739 72.5491 60.3339 71.4899 60.8831 70.7345L91.4511 28.6853C91.9281 28.029 92.953 28.2159 93.1674 28.9982L96.4434 40.9477C96.5211 41.231 96.4657 41.5342 96.293 41.7718L74.4672 71.7953Z",
    fill: "url(#paint2_linear_25514_11391)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0534 41.9489C55.8084 41.8829 56.3705 41.217 56.2669 40.4667C55.5886 35.5511 53.5898 30.9013 50.4718 27.0179C47.067 22.7773 42.4805 19.6409 37.2922 18.0055C32.1039 16.3701 26.5468 16.309 21.3238 17.83C16.1008 19.351 11.4463 22.3858 7.94903 26.5506C4.45175 30.7153 2.26871 35.8231 1.67598 41.2278C1.08324 46.6326 2.10743 52.0917 4.61904 56.9147C7.13064 61.7377 11.0168 65.708 15.7862 68.3237C20.1539 70.7189 25.0825 71.8796 30.044 71.6946C30.8013 71.6663 31.36 70.9976 31.294 70.243L30.527 61.4725C30.4611 60.718 29.7949 60.166 29.0371 60.1669C26.3554 60.17 23.7081 59.4972 21.3442 58.2008C18.578 56.6838 16.3241 54.3811 14.8675 51.5838C13.4108 48.7866 12.8168 45.6205 13.1606 42.4859C13.5044 39.3513 14.7705 36.3889 16.7988 33.9735C18.8271 31.558 21.5266 29.7979 24.5558 28.9158C27.585 28.0336 30.808 28.0691 33.817 29.0176C36.8261 29.9661 39.4862 31.7851 41.4609 34.2445C43.1485 36.3464 44.2707 38.8353 44.7328 41.4754C44.8634 42.2215 45.523 42.7814 46.2779 42.7154L55.0534 41.9489Z",
    fill: "url(#paint3_linear_25514_11391)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.851 23.3841C130.308 22.7798 130.19 21.9166 129.563 21.4907C125.458 18.7003 120.665 17.0676 115.691 16.7787C110.26 16.4633 104.858 17.7646 100.166 20.518C95.4753 23.2714 91.7065 27.3532 89.3366 32.2473C86.9666 37.1414 86.102 42.6279 86.852 48.0131C87.6021 53.3984 89.9331 58.4403 93.5503 62.5015C97.1675 66.5627 101.908 69.4607 107.174 70.8289C112.439 72.1972 117.992 71.9744 123.13 70.1886C127.836 68.5532 132 65.6743 135.187 61.8694C135.674 61.2886 135.551 60.4261 134.947 59.9694L127.919 54.6623C127.314 54.2057 126.458 54.33 125.951 54.8928C124.156 56.8846 121.883 58.3979 119.336 59.2831C116.355 60.3188 113.135 60.4481 110.081 59.6545C107.027 58.8609 104.277 57.18 102.179 54.8246C100.081 52.4691 98.7294 49.5447 98.2944 46.4213C97.8594 43.2979 98.3608 40.1157 99.7354 37.2771C101.11 34.4385 103.296 32.0711 106.017 30.4741C108.738 28.8771 111.871 28.1224 115.021 28.3053C117.713 28.4617 120.314 29.2968 122.585 30.723C123.226 31.1261 124.084 31.0119 124.541 30.4076L129.851 23.3841Z",
    fill: "url(#paint4_linear_25514_11391)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.563 21.4907C130.19 21.9166 130.308 22.7798 129.851 23.3841L124.541 30.4076C124.084 31.0119 123.226 31.1261 122.585 30.723C120.314 29.2968 117.713 28.4617 115.021 28.3053C111.871 28.1224 108.738 28.8771 106.017 30.4741C103.296 32.0711 101.11 34.4385 99.7354 37.2771C98.3608 40.1157 97.8594 43.2979 98.2944 46.4213C98.7294 49.5447 100.081 52.4691 102.179 54.8246C104.277 57.18 107.027 58.8609 110.081 59.6545C113.135 60.4481 116.355 60.3188 119.336 59.2831C121.883 58.3979 124.156 56.8846 125.951 54.8928C126.458 54.33 127.314 54.2057 127.919 54.6623L134.947 59.9694C135.551 60.4261 135.674 61.2886 135.187 61.8694C132 65.6743 127.836 68.5532 123.13 70.1886C117.992 71.9744 112.439 72.1972 107.174 70.8289C101.908 69.4607 97.1675 66.5627 93.5503 62.5015C89.9331 58.4403 87.6021 53.3984 86.852 48.0131C86.102 42.6279 86.9666 37.1414 89.3366 32.2473C91.7065 27.3532 95.4753 23.2714 100.166 20.518C104.858 17.7646 110.26 16.4633 115.691 16.7787C120.665 17.0676 125.458 18.7003 129.563 21.4907Z",
    fill: "url(#paint5_linear_25514_11391)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25514_11391",
    x1: -11.8003,
    y1: 121.47,
    x2: 88.8431,
    y2: -17.1326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6C2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25514_11391",
    x1: -11.8003,
    y1: 121.47,
    x2: 88.8431,
    y2: -17.1326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6C2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25514_11391",
    x1: -11.8003,
    y1: 121.47,
    x2: 88.8431,
    y2: -17.1326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6C2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_25514_11391",
    x1: 31.0262,
    y1: 20.9561,
    x2: 29.9755,
    y2: 86.5477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407195,
    stopColor: "#FF6C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#FF6C2F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_25514_11391",
    x1: 126.852,
    y1: 21.1847,
    x2: 90.9761,
    y2: 80.4028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407195,
    stopColor: "#FF6C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#FF6C2F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_25514_11391",
    x1: 126.852,
    y1: 21.1847,
    x2: 90.9761,
    y2: 80.4028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407195,
    stopColor: "#FF6C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#FF6C2F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.bb70adca855e198fa3f6d0f36caed3aa.svg";
export { ForwardRef as ReactComponent };